import { ReactNode } from 'react';
import styled from '@emotion/styled';
import Dialog from 'presentations/views/components/atoms/Dialog';
import DialogSubmitField from 'presentations/views/components/molecules/DialogSubmitField';
import { fontSize, fontWeight, spacing } from 'presentations/views/styles';

interface Props {
  isOpen: boolean;
  onSubmit?: any;
  isLoading?: boolean;
  onCancel?: any;
  title: string;
  subTitle?: string;
  text?: ReactNode | string;
  supplementText?: ReactNode | string;
  submitLabel?: string;
  cancelLabel?: string;
  submitField?: ReactNode | null;
}

export default function Component(props: Props) {
  return (
    <Dialog isOpen={props.isOpen} onClose={props.onCancel}>
      <Title>{props.title}</Title>
      {props.subTitle && <Text>{props.subTitle}</Text>}
      <Text>
        {props.text}
        {props.supplementText && (
          <>
            <br />
            {props.supplementText}
          </>
        )}
      </Text>
      {props.submitField ? (
        props.submitField
      ) : (
        <DialogSubmitField
          isLoading={props.isLoading}
          onSubmit={props.onSubmit}
          onCancel={props.onCancel}
          submitLabel={props.submitLabel}
          cancelLabel={props.cancelLabel}
        />
      )}
    </Dialog>
  );
}

const Title = styled.div`
  font-weight: ${fontWeight('bold')};
  font-size: ${fontSize(20)};
  margin-bottom: ${spacing(16)};
  text-align: center;
  white-space: pre-wrap;
`;
const Text = styled.div`
  text-align: center;
  margin-bottom: ${spacing(40)};
  white-space: pre-wrap;
`;
